export default {"src":"/_next/static/media/ready_to_use.919f1a83.svg","height":19,"width":22,"blurWidth":0,"blurHeight":0};